<template>
  <qx-card-form title="结算方式">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="split"></section>
      <div slot="recive" slot-scope="prop">
        <div
          v-show="
            prop.form.dispatchBalanceType === '1' ||
            prop.form.dispatchBalanceType === '2'
          "
        >
          离场日期+
          <el-input
            class="inputBox1"
            v-model="otherFormData.dispatchReciveTime"
            placeholder="请输入"
          >
            <span slot="suffix" class="inputSlotText">天</span>
          </el-input>
        </div>
        <div v-show="prop.form.dispatchBalanceType === '3'">
          <el-input
            class="appendInputBox"
            v-model="otherFormData.dispatchReciveMonth"
            placeholder="请输入"
          >
            <span slot="suffix">
              个月后
              <el-select
                class="inputAppendSelect"
                v-model="otherFormData.dispatchReciveTimeDay"
                :clear="true"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in 31"
                  :key="item"
                  :label="item + '号'"
                  :value="item"
                />
              </el-select>
            </span>
          </el-input>
        </div>
      </div>
      <div slot="collection" slot-scope="prop">
        <div v-show="prop.form.dispatchBalanceType === '2'">
          回单审核后+
          <el-input
            class="inputBox2"
            v-model="otherFormData.dispatchCollectionTime"
            placeholder="请输入"
          >
            <span slot="suffix" class="inputSlotText">天</span>
          </el-input>
        </div>
        <div v-show="prop.form.dispatchBalanceType === '3'">
          <el-input
            class="appendInputBox"
            v-model="otherFormData.dispatchCollectionMonth"
            placeholder="请输入"
          >
            <span slot="suffix">
              个月后
              <el-select
                class="inputAppendSelect"
                v-model="otherFormData.dispatchCollectionTimeDay"
                :clear="true"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in 31"
                  :key="item"
                  :label="item + '号'"
                  :value="item"
                />
              </el-select>
            </span>
          </el-input>
        </div>
      </div>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  getEnumList,
} from 'api';
export default {
  data () {
    return {
      otherFormData: {
        dispatchReciveTime: '', // 回单期限天数
        dispatchReciveMonth: '', // 回单期限第几个月
        dispatchReciveTimeDay: '', // 回单期限第几号
        dispatchCollectionTime: '', // 收款期限天数
        dispatchCollectionMonth: '', // 收款期限第几个月
        dispatchCollectionTimeDay: '', // 收款期限第几号
      },
      baseForm: {
        dispatchBalanceTypeOptions: [],
        inline: true,
        form: [
          {
            label: '结算方式',
            value: 'dispatchBalanceType',
            type: 'select',
            width: '240px',
            onChange: () => {
              this.handleLabelTypeChange();
            },
          },
          {
            label: '回单期限',
            value: 'recive',
            slot: true,
          },
          {
            label: '收款期限',
            value: 'collection',
            slot: true,
            hide: false,
          },
        ],
        rules: {
          dispatchBalanceType: [ // 结算方式
            { required: true, message: '请选择结算方式', trigger: 'blur' },
          ],
          // recive: [ // 回单期限
          //   { validator: this.checkRecive, trigger: 'blur' },
          // ],
          // collection: [ // 收款期限
          //   { validator: this.checkCollection, trigger: 'blur' },
          // ],
        },
      },
    };
  },
  methods: {

    async getOptions () {
      if (!this.baseForm.dispatchBalanceTypeOptions.length) {
        const enumList = await getEnumList({
          codeType: 'BALANCE_TYPE',
        });
        this.baseForm.dispatchBalanceTypeOptions = enumList[0];
      }
    },

    setValueFromCustomer (data) {
      this.$refs.baseForm.setVal('dispatchBalanceType', data.payWay);
      this.otherFormData = {
        dispatchReciveTime: data ? data.dispatchReciveTime : '', // 回单期限天数
        dispatchReciveMonth: data ? (data.dispatchReciveMonth || data.dispatchReciveTime) : '', // 回单期限第几个月
        dispatchReciveTimeDay: data ? (data.reciveDay || data.reciveDay) : '', // 回单期限第几号
        dispatchCollectionTime: data ? data.dispatchCollectionTime : '', // 收款期限天数
        dispatchCollectionMonth: data ? (data.dispatchCollectionMonth || data.dispatchCollectionTime) : '', // 收款期限第几个月
        dispatchCollectionTimeDay: data ? (data.collectionDay || data.collectionDay) : '', // 收款期限第几号
      };
      this.handleLabelTypeChange();
    },

    /**
     * @param {Array} rule 规则
     * @param {String} value 当前值
     * @param {Function} call 结果执行
     * @returns {void}
     * @description 验证回单期限
     */
    checkRecive (rule, value, call) {
      const dispatchBalanceType = this.$refs.baseForm.getVal('dispatchBalanceType');
      if ((dispatchBalanceType === '1' || dispatchBalanceType === '2') && !this.otherFormData.dispatchReciveTime) {
        call('请输入回单期限天数');
      } else if (dispatchBalanceType === '3' && (!this.otherFormData.dispatchReciveMonth || !this.otherFormData.dispatchReciveTimeDay)) {
        call('请输入回单期限天数');
      } else {
        call();
      }
    },

    /**
     * @param {Array} rule 规则
     * @param {String} value 当前值
     * @param {Function} call 结果执行
     * @returns {void}
     * @description 验证收款期限
     */
    checkCollection (rule, value, call) {
      const dispatchBalanceType = this.$refs.baseForm.getVal('dispatchBalanceType');
      if (dispatchBalanceType === '2' && !this.otherFormData.dispatchCollectionTime) {
        call('请输入收款期限天数');
      } else if (dispatchBalanceType === '3' && (!this.otherFormData.dispatchCollectionMonth || !this.otherFormData.dispatchCollectionTimeDay)) {
        call('请输入收款期限天数');
      } else {
        call();
      }
    },
    handleLabelTypeChange () {
      const dispatchBalanceType = this.$refs.baseForm.getVal('dispatchBalanceType');
      let isNotAuto = dispatchBalanceType === '1';
      const tar = ['collection'];
      this.baseForm.form.forEach((item) => {
        if (tar.indexOf(item.value) !== -1) {
          item.hide = isNotAuto;
        }
      });
    },
    async cacheData () {
      let res = await this.$refs.baseForm.getVal();
      res = {
        dispatchBalanceType: res.dispatchBalanceType,
        ...this.otherFormData,
      };
      return res;
    },

    async sub () {
      let formData = await this.$refs.baseForm.sub();
      if (formData) {
        formData = {
          dispatchBalanceType: formData.dispatchBalanceType,
          payWay: formData.dispatchBalanceType,
          ...this.otherFormData,
        };
        if (`${formData.dispatchBalanceType}` === '3') {
          formData.dispatchCollectionTime = formData.dispatchCollectionMonth;
          formData.dispatchReciveTime = formData.dispatchReciveMonth;
        }

        const dispatchInfo = {
          ['dispatchInfo.dispatchBalanceData.balanceType']: formData.dispatchBalanceType,
          ['dispatchInfo.dispatchBalanceData.isCost']: true,
          ['dispatchInfo.dispatchBalanceData.reciveDay']: formData.dispatchReciveTimeDay,
          ['dispatchInfo.dispatchBalanceData.collectionDay']: formData.dispatchCollectionTimeDay,
          ['dispatchInfo.dispatchBalanceData.reciveTime']: formData.dispatchReciveTime,
          ['dispatchInfo.dispatchBalanceData.collectionTime']: formData.dispatchCollectionTime,
          ['dispatchInfo.dispatchBalanceData.reciveMonth']: formData.dispatchReciveMonth,
          ['dispatchInfo.dispatchBalanceData.collectionMonth']: formData.dispatchCollectionMonth,
        };

        formData = dispatchInfo;
      }
      return formData;
    },
    setDetailData (data) {
      if (data.costPaymentDaysInfo) {
        data.dispatchBalanceType = data.costPaymentDaysInfo.balanceType;
        if (data.dispatchBalanceType === 1) {
          data.dispatchReciveTime = data.costPaymentDaysInfo.reciveTime;
        }
        if (data.dispatchBalanceType === 2) {
          data.dispatchReciveTime = data.costPaymentDaysInfo.reciveTime;
          data.dispatchCollectionTime = data.costPaymentDaysInfo.collectionTime;
        }
        if (data.dispatchBalanceType === 3) {
          data.dispatchReciveMonth = data.costPaymentDaysInfo.reciveMonth;
          data.dispatchReciveTimeDay = data.costPaymentDaysInfo.reciveDay;
          data.dispatchCollectionMonth = data.costPaymentDaysInfo.collectionMonth;
          data.dispatchCollectionTimeDay = data.costPaymentDaysInfo.collectionDay;
        }
      }
    },
    async init (data = {}) {
      await this.getOptions();

      this.setDetailData(data);

      let dispatchBalanceType = this.baseForm.dispatchBalanceTypeOptions[0].value;
      if (data.dispatchBalanceType !== undefined) {
        data.dispatchBalanceType = String(data.dispatchBalanceType);
      } else {
        data.dispatchBalanceType = dispatchBalanceType;
      }

      this.$refs.baseForm.setVal('dispatchBalanceType', data.dispatchBalanceType);

      this.otherFormData = {
        dispatchReciveTime: data ? data.dispatchReciveTime : '', // 回单期限天数
        dispatchReciveMonth: data ? (data.dispatchReciveMonth || data.dispatchReciveTime) : '', // 回单期限第几个月
        dispatchReciveTimeDay: data ? (data.dispatchReciveTimeDay || data.dispatchReciveTimeDay) : '', // 回单期限第几号
        dispatchCollectionTime: data ? data.dispatchCollectionTime : '', // 收款期限天数
        dispatchCollectionMonth: data ? (data.dispatchCollectionMonth || data.dispatchCollectionTime) : '', // 收款期限第几个月
        dispatchCollectionTimeDay: data ? (data.dispatchCollectionTimeDay || data.dispatchCollectionTimeDay) : '', // 收款期限第几号
      };
      this.handleLabelTypeChange();
    },
  },
};
</script>

<style scoped lang="scss">
.inputBox1 {
  width: 172px;
}
.inputBox2 {
  width: 158px;
}
</style>
